/**
 * 告知函催签提示：先弹框「去签署」，确认后再打开活体/手签（对齐欠费提示交互）。
 */
import { ElMessageBox } from 'element-plus'
import { isAgreementGateBlocking } from '@/utils/agreementGate'

let isShowingNoticePrompt = false
/** @type {null | ((opts?: { skipPrompt?: boolean }) => void | Promise<void>)} */
let openGatesHandler = null

export function registerOpenAgreementGates(handler) {
  openGatesHandler = handler
}

export function isNoticeSignPromptShowing() {
  return isShowingNoticePrompt
}

function defaultNoticeMessage(payload) {
  if (payload?.noticePhase === 2) {
    return '请先完成二阶段告知函签署后再继续'
  }
  if (payload?.noticePhase === 1) {
    return '请先完成一阶段告知函签署后再继续'
  }
  return '请先完成告知函签署后再继续学习'
}

/**
 * 进课/考试等返回 1004 时调用：弹框 → 去签署 → 打开闸门流程。
 * 闸门已占用（ensureGates 催签中）时不叠弹，避免红字/双弹框。
 */
export function handleNoticeSignPrompt(message, payload) {
  if (isShowingNoticePrompt) return
  // ensureGates 已在催签流程中：由闸门自己的「去签署」承接，勿再弹一层
  if (isAgreementGateBlocking()) return
  showNoticeSignConfirm(message || defaultNoticeMessage(payload), payload)
}

/**
 * ensureGates 在打开二维码/手签前调用：用户确认后再继续。
 * @returns {Promise<boolean|null>} true=去签署；false=取消；null=已有弹框进行中（勿 releaseGates）
 */
export function confirmBeforeOpenNoticeSign(message, payload) {
  if (isShowingNoticePrompt) {
    return Promise.resolve(null)
  }
  return showNoticeSignConfirm(message || defaultNoticeMessage(payload), payload, true)
}

function showNoticeSignConfirm(message, payload, returnBoolOnly = false) {
  isShowingNoticePrompt = true
  ;(window).__noticeGatePromptPending = true
  return ElMessageBox.confirm(message, '提示', {
    confirmButtonText: '去签署',
    cancelButtonText: '取消',
    type: 'warning',
    closeOnClickModal: false,
  })
    .then(async () => {
      if (returnBoolOnly) {
        return true
      }
      if (openGatesHandler) {
        await openGatesHandler({ skipPrompt: true, checkRes: payload })
      }
      return true
    })
    .catch(() => false)
    .finally(() => {
      isShowingNoticePrompt = false
      ;(window).__noticeGatePromptPending = false
    })
}
